// extracted by mini-css-extract-plugin
export var checkbox = "_45-0";
export var circle = "_45-3";
export var horizontalContainer = "_45-7";
export var sm = "_45-5";
export var switch0 = "_45-2";
export var switchDisabled = "_45-8";
export var switchEnabled = "_45-1";
export var textSwitchContainer = "_45-9";
export var textSwitchOption = "_45-a";
export var textSwitchOptionSelected = "_45-b";
export var verticalContainer = "_45-6";
export var xs = "_45-4";